import React, { useEffect, useState } from "react";
import cal_link_maker from "../../Functions/cal_link_maker";
import { Backtotop, Eventcard } from "../../widgets";
import EventShowcase from "../../containers/EventShowcase/EventShowcase";
import "./Freshers_asso.css";
import { freshers_events } from "../../constants/freshers_asso";
import {FaComputer} from 'react-icons/fa6'

import {
  freshers_asso_heroimage_carousalinfo,
  freshersmenu,
  freshers_workshops
} from "../../constants/freshers_asso";

import { Heroimagecarousal,RadialMenu } from "../../components";
import { Deptvision, Deptmission, Underline,Floatinmenu } from "../../widgets";

const Freshers_workshops = () => {
  useEffect(() => {
    document.title = "ACCET-Freshers' Association";
  }, []);
  // Move event logic to main component scope
  const cardsToShowInitially = 12;
  const cardsIncrement = 4;

  const totalCards = freshers_events.length;

  const [visibleCards, setVisibleCards] = useState(cardsToShowInitially);

  const handleReadMoreClick = () => {
    const newVisibleCards = visibleCards + cardsIncrement;
    setVisibleCards(Math.min(newVisibleCards, totalCards));
  };

  const handleReadLessClick = () => {
    setVisibleCards(cardsToShowInitially);
  };

  const shouldShowReadMore = visibleCards < totalCards;
  const shouldShowReadLess = visibleCards === totalCards;
  return (
    <div className="freshersdept">
      <Heroimagecarousal
        key={freshers_asso_heroimage_carousalinfo.id}
        title={freshers_asso_heroimage_carousalinfo.title}
        img_list={freshers_asso_heroimage_carousalinfo.img_list}
      ></Heroimagecarousal>
      <section className="freshersdark">
        <div className="dept_float_menu">
          <Floatinmenu logo={FaComputer} head="Menu" links={freshersmenu} />
        </div>
        <RadialMenu menu_links={freshersmenu} />
       <div className="freshers_event">
         {freshers_workshops.map((evt, i) => {
              const { id, heading, date, organizer, content, images } = evt;
              return (
                <EventShowcase
                  key={id ?? i}
                  heading={heading}
                  date={date}
                  organizer={organizer}
                  content={content}
                  images={images}
                />
              );
            })}
       </div>
      </section>
      <Backtotop />
    </div>
  );
};

export default Freshers_workshops;
